import React from "react";
import PropTypes from 'prop-types';
import {joinClassNames} from "@utahdts/dts-react-common";
import {iconCarretRight} from "../common/Icon";
import {COBI_HIERARCHY, MEDIA_SIZES} from "../misc/Shared";
import {Link} from 'react-router-dom';
import Media from "react-media";

const propTypes = {
	cobiId: PropTypes.number.isRequired,
	link: PropTypes.string.isRequired,
	loadMenu: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	navigate: PropTypes.func,
	selected: PropTypes.bool.isRequired,
	type: PropTypes.string.isRequired,
	classNames: PropTypes.string,
};

const defaultProps = {
	navigate: undefined,
};

class MainMenuItem extends React.Component {
	constructor(props) {
		super(props);

		this.clickMenuItem = this.clickMenuItem.bind(this);
	}

	clickMenuItem(e) {
		if (this.props.selected || this.props.type === COBI_HIERARCHY.PROGRAM) {
			//navigate to the link
			this.props.navigate(this.props.link);
		} else {
			//query API for menu items
			e.preventDefault();
			this.props.loadMenu(this.props.cobiId);
		}
	}

	renderArrowIcon() {
		return (
			<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}>
				{matches =>
					matches ? (
						iconCarretRight()
					) : (
						this.props.selected ? iconCarretRight() : <span className="svg-icon svg-carret-right"/>
					)
				}
			</Media>
		);
	}

	render () {
		return (
			<li className={joinClassNames(this.props.selected ? 'selected': undefined, `menu-item-${this.props.cobiId}`, this.props.classNames)}>
				<Link to={this.props.link} className="flex align-center" onClick={e => this.clickMenuItem(e)}>
					<span className="flex1">{this.props.name}</span>
					{this.renderArrowIcon()}
				</Link>
			</li>
		);
	}
}

MainMenuItem.propTypes = propTypes;
MainMenuItem.defaultProps = defaultProps;

export default MainMenuItem;
